import { ActionsUnion } from "common/reducers/UtilsTypes";
import { IPresentationData, PresentationRecord } from "common/records/Presentation";
import { createAction } from "common/reducers/Utils";
import { List } from "immutable";

// SINGLE
export const SET_CURRENT_PRESENTATION_ID = "@presentations/SET_CURRENT_PRESENTATION_ID";
export const FETCH_PRESENTATION = "@presentations/FETCH_PRESENTATION";
export const RECEIVE_PRESENTATION = "@presentations/RECEIVE_PRESENTATION";
export const SET_PRESENTATION_LOADED = "@presentations/SET_PRESENTATION_LOADED";
export const REMOVE_PRESENTATION = "@presentations/REMOVE_PRESENTATION";
export const EDIT_PRESENTATION = "@presentations/EDIT_PRESENTATION";
export const RESET_PRESENTATION = "@presentations/RESET_PRESENTATION";
export const ADD_SLIDE = "@presentations/ADD_SLIDE";
export const REMOVE_SLIDE = "@presentations/REMOVE_SLIDE";
export const JOB_PRESENTATION_SORT_END = "@presentations/JOB_PRESENTATION_SORT_END";
export const INITIALIZE_JOB_PRESENTATION = "@presentations/INITIALIZE_JOB_PRESENTATION";
// MULTIPLE
export const FETCH_PRESENTATIONS = "@presentations/FETCH_PRESENTATIONS";
export const RECEIVE_PRESENTATIONS = "@presentations/RECEIVE_PRESENTATIONS";
export const SET_PRESENTATIONS_LOADED = "@presentations/SET_PRESENTATIONS_LOADED";
export const EDIT_PRESENTATIONS = "@presentations/EDIT_PRESENTATIONS";
export const SET_LOADING = "@presentations/SET_LOADING";
export const ADD_SLIDES = "@presentations/ADD_SLIDES";
export const REMOVE_SLIDES = "@presentations/REMOVE_SLIDES";

export const PresentationActions = {
  setCurrentPresentationId: (id: number) => createAction(SET_CURRENT_PRESENTATION_ID, { id }),
  fetchPresentation: (id: number) => createAction("@presentations/FETCH_PRESENTATION", { id }),
  receivePresentation: (presentation: Partial<IPresentationData>) =>
    createAction("@presentations/RECEIVE_PRESENTATION", { presentation }),
  setPresentationLoaded: (id: number) => createAction("@presentations/SET_PRESENTATION_LOADED", { id }),
  editPresentation: (id: number, name: string, value: any) =>
    createAction("@presentations/EDIT_PRESENTATION", { id, name, value }),
  resetPresentation: (id: number) => createAction("@presentations/RESET_PRESENTATION", { id }),

  fetchPresentations: (ids: List<number>) => createAction("@presentations/FETCH_PRESENTATIONS", { ids }),
  receivePresentations: (presentations: Partial<IPresentationData>[]) =>
    createAction("@presentations/RECEIVE_PRESENTATIONS", { presentations }),
  setPresentationsLoaded: (ids: List<number>) => createAction("@presentations/SET_PRESENTATIONS_LOADED", { ids }),
  removePresentation: (id: number) => createAction("@presentations/REMOVE_PRESENTATION", { id }),
  editPresentations: (ids: List<number>, name: string, value: any) =>
    createAction("@presentations/EDIT_PRESENTATIONS", { ids, name, value }),
  setLoading: (loading: boolean) => createAction("@presentations/SET_LOADING", { loading }),
  addSlide: (
    dynamicPresentation: PresentationRecord,
    slideId: number,
    orgPresentations: List<PresentationRecord>,
    sortOrder = "default",
  ) => createAction(ADD_SLIDE, { dynamicPresentation, slideId, orgPresentations, sortOrder }),
  removeSlide: (dynamicPresentation: PresentationRecord, slideId: number) =>
    createAction(REMOVE_SLIDE, { dynamicPresentation, slideId }),
  addSlides: (
    dynamicPresentation: PresentationRecord,
    presentation: PresentationRecord,
    orgPresentations: List<PresentationRecord>,
    sortOrder = "default",
  ) => createAction(ADD_SLIDES, { dynamicPresentation, presentation, orgPresentations, sortOrder }),
  removeSlides: (dynamicPresentation: PresentationRecord, presentation: PresentationRecord) =>
    createAction(REMOVE_SLIDES, { dynamicPresentation, presentation }),
  jobPresentationSortEnd: (presentation: PresentationRecord, oldIndex: number, newIndex: number) =>
    createAction(JOB_PRESENTATION_SORT_END, { presentation, oldIndex, newIndex }),
  initializeJobPresentation: (jobId: number, inspectionId: number) =>
    createAction(INITIALIZE_JOB_PRESENTATION, { jobId, inspectionId }),
};

export type PresentationActions = ActionsUnion<typeof PresentationActions>;
